import { CodeleapQueryClient, ReactQuery } from '@codeleap/common'

const queryClient = new CodeleapQueryClient(new ReactQuery.QueryClient())

export { queryClient }
